import * as designTokens from './designTokens'

type JsonValue = string | number | JsonObject
interface JsonObject {
  [key: string]: JsonValue
}

const jsonToCssVars = (jsonObj: JsonValue, prefix = '') => {
  let cssVariables = ''

  if (typeof jsonObj === 'object' && jsonObj !== null) {
    for (const key in jsonObj) {
      const value = (jsonObj as JsonObject)[key]
      if (typeof value === 'object' && value !== null) {
        cssVariables += jsonToCssVars(
          value,
          Boolean(prefix) ? `${prefix}-${key}` : key,
        )
      } else {
        const variableName = `--${prefix}-${key}`
        cssVariables += `${variableName}: ${value};\n`
      }
    }
  }

  return cssVariables
}

const WIDTH_BREAKPOINT = 600

const designTokensCssVarsDeclaration = `
  :root {
    /* Global vars - by the moment they're not used (defined in MUI theme)
    ${jsonToCssVars(designTokens.globals)}  */

    /* Media query for larger screens */
    @media (max-width: ${WIDTH_BREAKPOINT}px) {
      ${jsonToCssVars(designTokens.sm)}
    }

    /* Media query for smaller screens */
    @media (min-width: ${WIDTH_BREAKPOINT + 1}px) {
      ${jsonToCssVars(designTokens.lg)}
    }
  }
`

export const createDesignTokensCssVars = () => {
  const style = document.createElement('style')
  style.textContent = designTokensCssVarsDeclaration
  document.head.appendChild(style)
}
